import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import Button from 'components/Buttons/Button';
import { literalTemplate } from 'utils/language';
import { ReactComponent as SendRequestIcon } from 'assets/svg/send-request.svg';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import { fetchStartup } from '../modules/actions';
import { REQUEST_ACCESS } from './OnboardingSteps';

function RenderStartupInvite({
  literals, id, startup, setStartup, setRender, external,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const auxStartup = await fetchStartup(id, external);
        setStartup(auxStartup);
      } catch (e) {
        navigate(ROUTE_PATH.ONBOARDING, { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return !startup
    ? <Loading mode='panel' />
    : (
      <div>
        <h3 className='step-title'>{literals.invitationManageStartup}</h3>
        <p className='step-message'>
          {literalTemplate(literals.invitationManageStartupMessage, {
            STARTUP: startup.name,
          })}
        </p>
        <SendRequestIcon className='panel-empty-message' />
        <div className='buttons'>
          <Button
            text={literals.requestAccess}
            onClick={() => setRender(REQUEST_ACCESS)}
          />
        </div>
      </div>
    );
}

RenderStartupInvite.propTypes = {
  literals: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  startup: PropTypes.object.isRequired,
  setStartup: PropTypes.func.isRequired,
  setRender: PropTypes.func.isRequired,
  external: PropTypes.func.isRequired,
};

export default RenderStartupInvite;
